import { useQueryClient } from '@tanstack/react-query';
import type { Seo } from '../../../@types/Seo';
import { SEO_SSR_SEARCH_QUERY } from './QueryKeys';

const useSeoSearch = () => {
  const queryClient = useQueryClient();
  return queryClient.getQueryData<Seo>([SEO_SSR_SEARCH_QUERY]);
};

export default useSeoSearch;
